import { useState, useEffect } from 'react';

import Toolbar from '@lcsc-ui/components/ToolBar';
import BaseLayout from '@lcsc-ui/layouts/baseLayout';
import useUserStore from '@lcsc-ui/store/user';
import ecpCurl from '@lcsc-ui/utils/ecpCurl';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

import OpApi from '@/apis/op';
import StaticdataApi from '@/apis/staticdata';
import wwwApi from '@/apis/www';

export default function Index({ resourceData, websiteSectionList, catalogList, headerAd, linksData }) {
  const metadata = {
    title: '友情链接-立创商城',
    description:
      '立创商城SZLCSC.COM一站式电子元器件采购自营商城，拥有13万+平米智能化仓储，海量现货，正品保证，支持一键BOM配单，最快4小时发货，为用户提供电子元器件线上采购服务。嘉立创集团提供“EDA软件/PCB CAM软件、PCB智造、元器件商城、 激光钢网/治具 、SMT贴片”为一体的电子全产业链服务，助力全球硬件创新。',
    additionalMetaTags: [
      {
        name: 'keywords',
        content: '立创商城,元器件,电子元器件,电子元器件商城,电子元器件采购网,嘉立创',
      },
    ],
  };
  const [logined, setLogined] = useState(false);
  const { updateUserInfo } = useUserStore(); // 监听路由
  const [isOldCus, setIsOldCus] = useState(false); // 是否为老用户
  useEffect(() => {
    autoRefreshLoginInfo();
    setIsOldCus(resourceData?.commonConfigVO?.existSendOrder || false);
  }, []);
  const autoRefreshLoginInfo = (data) => {
    updateUserInfo(data);
    setLogined(true);
    window.isLogin = true;
  };
  const handleLinkClick = (event) => {
    if (!confirm('确认打开链接进入第三方网站吗？')) {
      event.preventDefault();
    }
  };
  return (
    <>
      <NextSeo {...metadata}></NextSeo>
      <Head>
        <link rel="canonical" href={resourceData?.projectConfigVO.lcscWwwUrl + '/links.html'} />
      </Head>
      <BaseLayout
        resourceData={resourceData}
        websiteSectionList={websiteSectionList}
        catalogList={catalogList}
        headerAd={headerAd}
        isLgScreen={false}
        notIndexHeaderAdapter
        onlySScreen
        logined={logined}
        isNeedTopAd={true}
        isShowBottomAd={true}
      >
        <div className="w-full h-full bg-[#F6F8FA]">
          <section className="w-[1200px] m-[15px_auto_60px]">
            <section className="flex mt-[16px]">
              {linksData ? (
                <div className="w-[1200px] m-[0_auto_0] pb-[30px] box-border bg-white rounded-[10px]">
                  <div className="m-[0_20px]">
                    <div className="text-[16px] mt-[20px] pb-[10px] border-b border-solid border-[#f0f0f0] text-[#0093e6]">
                      首页友链
                    </div>
                    <div className="mt-[10px]">
                      <div className="w-full flex flex-wrap" data-spm="sy">
                        {linksData?.friendWebsiteList?.map((friendWebsite, index) => (
                          <div
                            key={index}
                            className="w-[150px] mr-[15px] truncate shrink-0 h-[25px] leading-[25px] text-[#666]"
                          >
                            <a
                              data-spm={index + 1}
                              href={friendWebsite.url}
                              title={friendWebsite.keyword}
                              target="_blank"
                              onClick={handleLinkClick}
                            >
                              {friendWebsite.keyword}
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="m-[0_20px]">
                    <div className="text-[16px] mt-[20px] pb-[10px] border-b border-solid border-[#f0f0f0] text-[#0093e6]">
                      内页链接
                    </div>
                    <div className="mt-[10px]">
                      <div className="w-full flex flex-wrap" data-spm="ny">
                        {linksData?.innerWebsiteList?.map((innerWebsite, index) => (
                          <div
                            key={index}
                            className="w-[150px] mr-[15px] truncate shrink-0 h-[25px] leading-[25px] text-[#666]"
                          >
                            <a
                              data-spm={index + 1}
                              href={innerWebsite.url}
                              target="_blank"
                              title={innerWebsite.keyword}
                              onClick={handleLinkClick}
                            >
                              {innerWebsite.keyword}
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="m-[0_20px]">
                    <div className="text-[16px] mt-[20px] pb-[10px] border-b border-solid border-[#f0f0f0] text-[#0093e6]">
                      联系方式
                    </div>
                    <div className="mt-[13px]">
                      <ul>
                        <li>
                          <span>合作邮箱：</span>
                          <span className="text-[#0093e6]">zhouqingming@szlcsc.com</span>
                        </li>
                        <li className="mt-[6px]">
                          <span>其它事项：</span>
                          合作链接需要和立创商城有一定的相关性，网站收录、排名和更新频率良好，可换首页和内页链接。
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ) : (
                <span>暂无数据</span>
              )}
            </section>
          </section>
        </div>
        <Toolbar isOldCus={isOldCus}></Toolbar>
      </BaseLayout>
    </>
  );
}

export async function getServerSideProps(context) {
  const { req } = context;
  const [resourceData, catalogList, websiteSectionList, headerAd, linksData] = await Promise.all([
    ecpCurl(StaticdataApi.resourceList, { headers: req.headers }),
    ecpCurl(StaticdataApi.catalogList, { headers: req.headers }),
    ecpCurl(OpApi.websiteSection, { headers: req.headers }),
    ecpCurl(OpApi.advertisingHeader),
    ecpCurl(wwwApi.links),
  ]);
  return {
    props: {
      resourceData,
      websiteSectionList,
      catalogList,
      headerAd,
      linksData,
    },
  };
}
